
import moment from 'moment';
import React from 'react';
import logger from '../../logging/logger';

class HistoryList extends React.Component {

    state ={
        history: [],
    }

    async validate(props){
        this.setState({ 
            history: props.liste,
        })
    }

    componentDidMount(){
        this.validate(this.props)
    }

    componentDidUpdate(newprops){
        if(this.props !== newprops){
            this.validate(newprops)
        }
    }

    async setDateienDownloadLinks(dateien){
        let tmp = [];
        logger.log("Hist", dateien)
        return tmp;
    }

    render() {
        logger.log("Hist", this.state.history)
        return (
            <div>
                <table className='table table-hover'>
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th>BG Grundsatz</th>
                            <th>Art</th>
                            <th>gemacht</th>
                            <th>nächster Termin</th>
                            {/* <th>gespeichert</th> */}
                            <th>Beurteilung</th>
                            <th>Kommentar</th>
                            <th>Dateien</th>
                        </tr>
                    </thead>
                    <tbody>
                    {this.state.history.map((untersuchung) => {
                        const dateiLinks = untersuchung.Datei.map((datei) => {
                            logger.log(datei);
                            return (
                                <div key={datei.id}>
                                    <a href={global.api_url + "datei/" + datei.id + `/${encodeURIComponent(datei.name)}`+"?authorization=" + global.auth.authToken.token + "&binary=true"} rel="noreferrer" target="_blank">
                                        <p className="datei-name" alt={moment(datei.updatedAt).format('DD.MM.YYYY - HH:mm:ss')}>{datei.name}</p>
                                    </a>
                                </div>
                            );
                        });
                        let status = "Aktuell";
                        if(untersuchung.status === "H"){
                            status = "Historie"
                        }
                        return (
                            <tr key={untersuchung.id}>
                                <td>{status}</td>
                                <td>{untersuchung.firmenkartei.bg_grundsatz}</td>
                                <td>{untersuchung.art}</td>
                                <td>{moment(untersuchung.gemacht_am).format('DD.MM.YY')}</td>
                                <td>{moment(untersuchung.naechster_termin).format('MM/YY')}</td>
                                <td>{untersuchung.beurteilung}</td>
                                <td>{untersuchung.kommentar}</td>
                                <td>{dateiLinks}</td>
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default HistoryList;